const formatID = (text) => {
    return text.slice(34, -1)
  }


export default formatID